import { TRemoteBankingContactsStore } from '~/store/remote-banking-contacts/types.ts';

export const remoteBankingContactsState: TRemoteBankingContactsStore = {
  publicLink: '',
  applicationId: '',
  id: '',
  formManager: null,
  appId: '',
  fileURL: '',
  docId: '',
  formPersons: [],
  formPersonsInfo: null,

  loading: false,
  error: null,
  status: '',
};
